import { FusionError, serializeFusionError } from '@fusion-advantage/backcompat'
import { stringId } from '@fusion-advantage/formlib'
import { err, ok, Result } from "neverthrow"
import { DeviceToCloudBlobType, insertDeviceToCloudBlob } from "../dal/ldbDeviceToCloudBlob"

export const insertEncounterFile = async (encounterGuid: string, file: File, upn: string): Promise<Result<{id: string}, FusionError>> => {
	let id = stringId(40)
	const fileParts = file.name.split('.')
	if(fileParts.length > 1) {
		id += '.' + fileParts.at(-1)
	}
	let bytes: Uint8Array
	try {
		// 20250829 Chrome and Edge do not support this one-shot method.
		// surrounding with try block in case something gets weird
		// in the future.
		// bytes = await file.bytes()
		const buf = await file.arrayBuffer()
		bytes = new Uint8Array(buf)
	} catch(ex) {
		return err(serializeFusionError('insertEncounterFile', ex))
	}
	const r = await insertDeviceToCloudBlob({
		type: DeviceToCloudBlobType.EncounterFile,
		encounterGuid,
		fileId: id,
		upn,
		data: bytes,
		bin: true,
		nextCodeNext: null,
		contentType: file.type,
	})
	if(r.isErr()) {
		return err(serializeFusionError('insertFile', r.error))
	}
	return ok({id})
}
